import React, { useContext } from "react";
import "../../../ui-styles/calling/incomingCallModal.css";
import "../../../ui-styles/animations/callAnimation.css";

import { LangCtx } from "../../../lib/context";

const OutgoingCall = (props) => {
    const { l } = useContext(LangCtx);
    let name =
        props && props.userData && props.userData.firstName ? props.userData.firstName : props?.userData?.name ? props.userData?.name : "";
    name += props && props.userData && props.userData.lastName ? " " + props.userData.lastName : "";
    return (
        <div className={props.ogCall ? "callModalCntnr showModal" : "callModalCntnr"}>
            <div className="callingCntnr">
                <div className="callingTB topHight">
                    <div className="callingHdr">
                        <span className="callHdrLTxt">{props.status}...</span>
                    </div>
                </div>

                <div className="callingBdy">
                    <div className="callAnimation">
                        <img
                            src={
                                props && props.userData && props.userData.profileImage && props.userData.profileImage.url
                                    ? props.userData.profileImage.url
                                    : "/images/icons/patient-default.png"
                            }
                            alt="profile pic"
                            className="profilePic"
                        />
                    </div>
                    <span className="nameTxt">{name}</span>
                    <audio className={props.ogCall ? "noVisible" : "noDisplay"} autoPlay loop>
                        <source src="/audio/phone_ringing.mp3" type="audio/mpeg" />
                        <source src="/audio/phone_ringing.ogg" type="audio/ogg" />
                    </audio>
                </div>

                <div className="callingTB btmHight">
                    <div className="callingFtr">
                        <div className="circleBtnItem">
                            <button className="callBtnItem dangerColor" onClick={(e) => props.handleOgcall()}>
                                <img src="/images/icons/phone.png" className="invertWhite" alt="icon" />
                            </button>
                            <span className="btnTxt">{l.end_call}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default OutgoingCall;
